import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { Link, useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Langpref from "./Langpref";
import imgUrl from "../../assets/images/imageUrl.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Services from "../../api/api";
import OffileDb from '../../config/pouchDB';
import Loader from "../loaders/loader";
import Customcircularprogress from "./Customcircularprogress.js";

import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      appversion: "1.0.0",
      headerLogo: imgUrl.logo,
      footerLogo: imgUrl.poweredby,
      brandaing: []
    };
  }

  componentDidMount() {
    OffileDb.setDatabase()
    let deviceuuid = localStorage.getItem('deviceuuid');
    this.getAppVersion()
    this.getAppLogos()
  }


  getAppVersion() {
    var param = {
      id: this.props.communityuid,
    };
    Services.getAppVersion(param).then((res) => {
      try{
        this.setState({ appversion: res.data.data.appVersion });
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  getAppLogos() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getCommunityBrandingByCommunityId(param).then((res) => {
        try{
          console.log(res)
          if (res.status == 200) {
            let hlogo = res.data.data.brandingDetails.filter(o => o.tagline == "headerlogo").map(o => o.icon)[0] || imgUrl.logo;
            let flogo = res.data.data.brandingDetails.filter(o => o.tagline == "footerlogo").map(o => o.icon)[0] || imgUrl.poweredby;
            this.setState({
              headerLogo: hlogo,
              footerLogo: flogo,
              isLoading: false
            });
            OffileDb.setData('applogos', res.data.data)
          } else {
            this.setState({
              isLoading: false
            });
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    } else {
      this.setState({
        isLoading: false
      });
    }
  }


  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    return (
      <>
        {
          templateID == 1 ? (
            <div className="template1-hader">
              <Loader isLoading={this.state.isLoading} />
              <div className="gridcontainer">
                <Grid container spacing={3} className="gridcontainer">
                  <Grid item xs={12}>
                    <h3 className="text-center zero questiontitle color-darkblue">{t('iMonitor')}</h3>
                    <p className=" text-center">
                      {this.state.isLoading ? (
                        <Loader isLoading={this.state.isLoading} />
                      ) : (<img className="regformquestionimg" src={this.state.headerLogo} />)
                      }
                    </p>
                    <p className="zero text-center steptitle text-version"><span>{"V: " + this.state.appversion}</span></p>
                  </Grid>
                </Grid>
              </div>
            </div>) : (

            <div className="gridcontainer">
              <Grid container spacing={3} className="gridcontainer">
                <Grid item xs={12} className="zero">
                  <div className="onboardingheaderdiv homepageheaderdiv">
                    <p className="zero text-center">
                      {this.state.isLoading ? (
                        <Loader isLoading={this.state.isLoading} />
                      ) : (<img className="oneimpactlogoimg" src={this.state.headerLogo} />)
                      }
                    </p>
                    <p className="getonboardedtext text-center">
                      <span>{"V: " + this.state.appversion}</span>
                    </p>

                    {
                      window.location.hash == '#/OnboardingRegVertical' || window.location.hash == '#/Onboardingslider' ? (
                        <p className="progressbarcontainer text-center">
                          <Customcircularprogress></Customcircularprogress>
                        </p>
                      ) : ('')
                    }

                    <div className="custom-shape-divider-bottom-1599722124">
                      <svg
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1200 120"
                        preserveAspectRatio="none"
                      >
                        <path
                          d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                          className="shape-fill"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </Grid>
                {
                  window.location.hash === '#/Onboarding' || window.location.hash === '#/Onboarding/' && <img className="oneimpactlogoimg imgmiddle mt-20px" src={this.state.footerLogo} />
                }
              </Grid>
            </div>)
        }


      </>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    langId: storeState.langId,
    selectedComponentObj: {},
  };
};

// const ThemeKnowYourRights = withTheme(KnowYourRights);
// const FinalThemeKnowYourRights = withStyles(useStyles)(ThemeKnowYourRights);
//const routeSettings = withRouter(Settings);
//export default connect(mapStateToProps, {})(routeSettings);

let routeOnboarding = withRouter(Header)
let transonboarding = withTranslation()(routeOnboarding);
export default connect(mapStateToProps, {})(transonboarding);

